import { useEffect, useState } from "react"

export type CfIdentity = {
  readonly email: string
  readonly name: string
  readonly givenName: string
  readonly familyName: string
  readonly initials: string
  readonly groups: ReadonlyArray<string>
}

const fallback: CfIdentity = {
  email: "",
  name: "User",
  givenName: "",
  familyName: "",
  initials: "U",
  groups: [],
}

const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/)
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
  }
  return (parts[0]?.[0] ?? "U").toUpperCase()
}

export function useCfIdentity(): CfIdentity {
  const [identity, setIdentity] = useState<CfIdentity>(fallback)

  useEffect(() => {
    fetch("/cdn-cgi/access/get-identity")
      .then((res) => {
        if (!res.ok) return null
        return res.json()
      })
      .then((data) => {
        if (!data) return
        const name = (data.name as string | undefined) ?? (data.email as string | undefined) ?? "User"
        setIdentity({
          email: (data.email as string | undefined) ?? "",
          name,
          givenName: (data.given_name as string | undefined) ?? "",
          familyName: (data.family_name as string | undefined) ?? "",
          initials: getInitials(name),
          groups: (data.groups as ReadonlyArray<string> | undefined) ?? [],
        })
      })
      .catch(() => {
        // Not behind CF Access (local dev) — keep fallback
      })
  }, [])

  return identity
}
